import { render } from "./OrganisationLicenses.vue?vue&type=template&id=7839f44a"
import script from "./OrganisationLicenses.vue?vue&type=script&lang=js"
export * from "./OrganisationLicenses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__